import AppBar from '../../components/shared/AppBar/AppBar';
import NavigationUtils from '../../utils/navigation.utils';
import { useEffect, useRef, useState } from 'preact/hooks';
import useTranslation from '../../localization/i18n.context';
import style from './InstallmentsPage.css';
import InstallmentsPageSkeleton from '../../components/Installments/InstallmentsPageSkeleton/InstallmentsPageSkeleton';
import InstallmentsPageView from '../../components/Installments/InstallmentsPageView/InstallmentsPageView';
import InstallmentsService from '../../services/installments.service';
import { InstallmentsParams } from './InstallmentParser';

export default function InstallmentsPage() {
  const { t } = useTranslation();
  const backRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [installments, setInstallments] = useState([]);
  const [currency, setCurrency] = useState('');
  const currentParams = new URLSearchParams(window.location.search);
  const amount = currentParams.get(InstallmentsParams.AMOUNT);
  const organizationCode = currentParams.get(
    InstallmentsParams.ORGANIZATION_CODE,
  );
  useEffect(() => {
    let _installments = null;
    const params = {
      organizationCode: organizationCode,
      amount: amount,
    };
    InstallmentsService.getInstallments(params)
      .then(({ data }) => {
        _installments = data.installments;
        _installments.sort((a, b) => a.installments - b.installments);
        setInstallments(_installments);
        setCurrency(data?.currency);
        setLoading(false);
      })
      .catch(err => {
        NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN);
      });
  }, []);

  return (
    <>
      <AppBar
        onBackClick={() => {
          NavigationUtils.back();
        }}
        onCloseClick={() => {
          NavigationUtils.endFlow();
        }}
        backRef={backRef}
        className="fixed-bar"
      />
      <div className={style.container}>
        {loading ? (
          <InstallmentsPageSkeleton className={style.skeleton} />
        ) : (
          <InstallmentsPageView
            className={style.content}
            installments={installments}
            currency={currency}
            organizationCode={organizationCode}
          />
        )}
      </div>
    </>
  );
}
